import { Component, OnInit } from '@angular/core';
import { LoadService } from '../services/load.service';

@Component({
  selector: 'app-sistema-carregando',
  templateUrl: './sistema-carregando.component.html',
  styleUrls: ['./sistema-carregando.component.css']
})
export class SistemaCarregandoComponent implements OnInit {

  loading: boolean;

  constructor(private loaderService: LoadService) {

    this.loaderService.isLoading.subscribe((v) => {
      // console.log(v);
      this.loading = v;
    });

  }
  ngOnInit() {
  }
}
